import axios from 'axios'


const donemDelete = async (data) => {
    let response;
    var config = {
        method: 'delete',
        url: process.env.REACT_APP_BASE_URL+'/api/v1/donem/delete',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            authorization : 'bearer '+ localStorage.getItem('accessToken')
        },
        data: data,
    };
    await axios(config)
        .then((res) => {
            
            response = res.data;
        })
        .catch((err) => {
            console.log(err);
        });
    return response;
};

export default donemDelete;
